//____ HEADER - LANGS MENU ____ //
//____ AUTHOR: LUBOMÍR BLAŽEK ____ //
function nl_fn_langs_menu() {
    $(document).on('click', '#lang .list-active .lang', function (e) {
        e.preventDefault();
        $(this).parent(".list-active").next(".list").toggleClass("active").slideToggle(500);
    });
}